import type { WhatsAppClient } from '@adornis/whatsapp/server/messager.js';

let _whatsapp: WhatsAppClient | null = null;

export const setWhatsapp = (whatsapp: WhatsAppClient) => {
  _whatsapp = whatsapp;
};

export const getWhatsapp = () => {
  if (!_whatsapp) throw new Error('No WhatsappClient Instance set!');
  return _whatsapp;
};
